import type { TrackingEvent } from '../types/tracking.types';
import { calculateNumItems } from '../utils/tracking.utils';

/**
 * Mapeamento de eventos para Pinterest Tag (pintrk)
 * Referência: Pixel_Pinterest.md (initiate_checkout, add_payment_info, checkout)
 */
// Nomes em PascalCase conforme documentação oficial do Pinterest
const PIN_EVENT_MAPPING: Record<string, string> = {
  begin_checkout: 'InitiateCheckout',
  add_payment_info: 'AddPaymentInfo',
  purchase: 'Checkout',
};

const buildPinterestPayload = (eventName: string, event: TrackingEvent): Record<string, any> => {
  const items = event.ecommerce?.items || [];
  const value = Number((event.ecommerce?.value ?? 0).toFixed(2));
  const currency = event.ecommerce?.currency || 'BRL';

  const payload: any = {
    value,
    currency,
    order_quantity: calculateNumItems(items), // campo correto do Pinterest (não num_items)
    line_items: items.map((i) => ({
      product_id: String(i.item_id),
      product_name: i.item_name,
      product_price: i.price,       // product_price (não item_price)
      product_quantity: i.quantity || 1, // product_quantity (não quantity)
    })),
  };

  const tx = (event.ecommerce as any)?.transaction_id;
  if (eventName === 'purchase' && tx) {
    payload.order_id = String(tx);
  }

  return payload;
};

/**
 * Envia evento para Pinterest Tag via pintrk('track', eventName, data)
 * Nota: o Pinterest Tag mantém um único tracker global; se você carregou múltiplos tagIds,
 * o comportamento padrão é enviar para todos eles.
 */
export const sendToPinterest = (_tagId: string, eventName: string, event: TrackingEvent, _universalEventId: string): void => {
  if (!_tagId || !(window as any).pintrk) return;

  try {
    const pinEventName = PIN_EVENT_MAPPING[eventName] ?? '';
    if (!pinEventName) return;

    const data = buildPinterestPayload(eventName, event);
    (window as any).pintrk('track', pinEventName, data);
  } catch (error) {
    console.error(`❌ Pinterest: Erro ao enviar evento ${eventName}:`, error);
  }
};

export const sendPageViewToPinterest = (_tagId: string, _universalEventId: string): void => {
  if (!_tagId || !(window as any).pintrk) return;

  try {
    // Pinterest Tag usa page() para page view
    (window as any).pintrk('page');
  } catch (error) {
    console.error('❌ Pinterest: Erro ao enviar PageView:', error);
  }
};

